import React, { useState, useEffect } from 'react';
import { Dropdown } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useNavigate } from 'react-router-dom';
import { createSelector } from 'reselect';
import { logoutUserSuccess } from 'slices/auth/login/reducer';

const ProfileDropdown = () => {
  const [userName, setUserName] = useState<string>("");
  const [email, setEmail] = useState<string>("");
  const [role, setRole] = useState<string>("");
  const navigate = useNavigate()
  const authUser = localStorage.getItem("authUser");
  const initial = userName ? userName.charAt(0).toUpperCase() : "?";

  const selectUser = createSelector(
    (state: any) => state.Profile,
    (user) => user?.user
  );
  const user = useSelector(selectUser);

  useEffect(() => {
    if (authUser) {
      const obj = JSON.parse(authUser);
      setUserName(obj?.name || "");
      setEmail(obj?.emailAddress || "");
      setRole(obj?.roleName || "");
    }
  }, [authUser]);

  const dispatch = useDispatch();

  const handleLogOut = () => {
    localStorage.clear()
    dispatch(logoutUserSuccess({}));
    setTimeout(() => {
      navigate('/login')
      window.location.reload()
    }, 555)
  }

  return (
    <React.Fragment>
      <Dropdown className="ms-sm-3 header-item topbar-user">
        <Dropdown.Toggle
          type="button"
          className="btn bg-transparent border-0 arrow-none"
          id="page-header-user-dropdown"
        >
          <span className="d-flex align-items-center">
            <div
              className="rounded-circle  text-white d-flex justify-content-center align-items-center mx-auto"
              style={{
                width: "30px",
                height: "30px",
                fontSize: "14px",
                fontWeight: "bold",
                backgroundColor: '#B7002A'
              }}
            >
              {initial}
            </div>
            <span className="text-start ms-xl">
              <span className="d-none d-xl-inline-block ms-1 fw-medium user-name-text text-dark">{userName}</span>
            </span>
          </span>
        </Dropdown.Toggle>

        <Dropdown.Menu className="dropdown-menu-end">
          <h6 className="dropdown-header">Welcome {userName}!</h6>

          <div className="px-3 pb-2">
            <div className="text-muted small"><strong>Email:</strong> {email || "-"}</div>
            <div className="text-muted small"><strong>Role:</strong> {role || "-"}</div>
          </div>

          <Dropdown.Divider />

          <Dropdown.Item>
            <Link to={process.env.PUBLIC_URL + "/user-profile"}>
              <i className="mdi mdi-account-circle text-muted fs-lg align-middle me-1"></i>
              <span className="align-middle  text-muted">Profile</span>
            </Link>
          </Dropdown.Item>
          <Dropdown.Item onClick={handleLogOut}><i className="mdi mdi-logout text-muted fs-lg align-middle me-1"></i> <span className="align-middle text-muted" data-key="t-logout">Logout</span></Dropdown.Item>
        </Dropdown.Menu>
      </Dropdown>
    </React.Fragment>
  );
};

export default ProfileDropdown;
